  <script setup>
  import { computed } from 'vue'
  const props = defineProps(
    {
        jerseyColor: {
            type: String,
            default: 'var(--black)0FF'
        },
        strokeColor: {
            type: String,
            default: 'var(--black)000'
        },
        size: {
            type: Number,
            default: 14
        }
    }
  )

  const getJerseyColor = computed(() => (props.jerseyColor.includes('#')) ? props.jerseyColor : '#' + props.jerseyColor)
  const getStrokeColor = computed(() => (props.strokeColor.includes('#')) ? props.strokeColor : '#' + props.strokeColor)
</script>

<template>
    <svg
      viewBox="0 0 24 24"
      fill="none"
      :height="size"
      :width="size"
      xmlns="http://www.w3.org/2000/svg"
      aria-label=""
      class="w-4 h-4"
    >
      <!-- Jersey Fill -->
      <path
        :fill="getJerseyColor"
        d="M6.00059 22V11.3347L2.00098 10.0015V6.43479C2.00098 5.36263 2.63926 4.39951 3.62745 3.98093L8.64779 2.00879L11.988 4.66738L15.3203 2L20.3631 3.98125C21.362 4.39885 21.999 5.3623 21.999 6.4413V10.0015L17.9994 11.3347V22H6.00059Z"
      />
      <!-- Outline Stroke -->
      <path
        :fill="getStrokeColor"
        d="M20.36 3.97998L17.46 2.83997L15.32 2L11.99 4.66998L8.65002 2.01001L6.48999 2.85999L3.63 3.97998C2.64001 4.39996 2 5.35998 2 6.42999V10L6 11.33V22H18V11.33L22 10V6.44C22 5.35998 21.36 4.39996 20.36 3.97998ZM21 9.27997L17 10.61V21H7V10.61L3 9.27997V6.42999C3 5.76996 3.40002 5.15997 3.98999 4.90997L7.39001 3.57995L11.99 7.22997L16.57 3.55999L19.98 4.89996C20.6 5.15997 21 5.76996 21 6.44V9.27997Z"
      />
    </svg>
  </template>

